<template>
    <div class="modal-window mas_cal">
        <header class="modal-header">
            <div class="tit">캘린더</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>

        <div class="modal-content" @wheel.passive="wheelEvent">
            <div class="calendar-cmn-area">
                <div class="calendar-cmn-tit">
                    <div class="btn-box">
                        <button type="button" @click="moveMonth(prevMonthType)">&lt; 이전</button>
                        <button type="button" @click="moveMonth(null)">다음 &gt;</button>
                    </div>
                    <div class="data-txt">
                        {{ selectMonthTitle }} 

                        <!-- 보드 목록 -->
                        <select v-model="selectPaperId" class="sel_ty1 txt-01" @change="monthToData">
                            <option value="ALL">전체</option>
                            <option value="">공통</option>
                            <option v-for="paper in paperList"
                            :value="paper.paperId"
                            :key="paper.paperId">{{ paper.paperTitle }}</option>
                        </select>

                        <!-- 일정 표시 개수 -->
                        <select v-model="showSortNumber" class="sel_ty1 txt-01">
                            <option v-for="sort in showSortList"
                            :value="sort"
                            :key="sort">{{ sort == 0 ? '전체' : sort + '개' }}</option>
                        </select>
                    </div>
                </div>
                <div class="calendar-cmn-box">
                    <div class="top-day-txt">
                        <div class="day">일요일</div>
                        <div class="day">월요일</div>
                        <div class="day">화요일</div>
                        <div class="day">수요일</div>
                        <div class="day">목요일</div>
                        <div class="day">금요일</div>
                        <div class="day">토요일</div>
                    </div>
                    <div class="bottom-day-box">
                        <div v-for="week in weekCount" :key="week" class="row">
                            <div v-for="(day, dayIndex) in weekDays[week - 1]" :key="day" 
                            class="day" 
                            :class="{ 
                                'pass': day < selectMonthStart || day > selectMonthEnd,
                                'off': day > selectMonthStart && day < selectMonthEnd && (dayIndex % 7 == 0 || dayIndex % 7 == 6)
                            }" 
                            @click="MAS_Cal_Detail($moment(day).format('YYYYMMDD'), todoMonth[day])">
                                <div class="num">{{ $moment(day).format("DD") }}</div>
                                <div class="day-detail">
                                    <ul v-if="todoMonth[day]">
                                        <li v-for="(todo, index) in todoMonth[day].slice(0, showSortNumber == 0 ? todoMonth[day].length: showSortNumber)" :key="index" 
                                        class="allday"
                                        :class="{'start': todo != null && (day == todo.todoStartDate.replaceAll('-', '') ) }"
                                        >
                                            <div v-if="todo" class="allday-box">
                                                <div class="txt" v-if="day == todo.todoStartDate.replaceAll('-', '') || dayIndex % 7 == 0"
                                                style="color:black"
                                                :title="'작성자 : ' + todo.regUserName"
                                                >{{ todo.todoTitle }}</div>
                                                <div v-else :title="'작성자 : ' + todo.regUserName">&nbsp;</div>
                                            </div>
                                            <div v-else></div>
                                        </li>
                                        <li v-if="showSortNumber != 0 && todoMonth[day].slice(showSortNumber).filter((t) => t != null).length > 0" class="more">
                                            <div class="txt">+{{ todoMonth[day].slice(showSortNumber).filter((t) => t != null).length }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Datepicker from 'vuejs-datepicker';
import EventBus from "@/js/eventbus/eventBus";
import MAS_Cal_Detail from "@/components/cowork/general/calendar/modal/MAS_Cal_Detail";
import MAS_Cal_List from "@/components/cowork/general/calendar/modal/MAS_Cal_List";

export default {
    components: {
        Datepicker,
    },
    props: {
        modalInfo: {
            type: Object,
        },
    },
    data() {
        return {
            selectMonth: this.$moment().format("YYYYMM"),
            selectMonthTitle: this.$moment().format("YYYY년 MM월"),
            selectMonthStart: this.$moment().startOf("months").format("YYYYMMDD"),
            selectMonthEnd: this.$moment().endOf("months").format("YYYYMMDD"),
            prevMonthType: 'P',
            startDate: this.$moment().startOf("months").startOf("weeks").format("YYYYMMDD"),
            endDate: this.$moment().endOf("months").endOf("weeks").format("YYYYMMDD"),
            todoMonth: {},
            weekDays: [],
            weekCount: 0,
            todoSort: [],
            showSortNumber: 3,
            showSortList: [0, 3, 5],
            paperList: [],
            selectPaperId: this.modalInfo.paperId,
        };
    },
    async mounted() {
        this.getBoardAllList();
        await this.monthToData();
    },
    created() {
        EventBus.$off("refreshTodoMonth");
        EventBus.$on("refreshTodoMonth", () => {
            this.monthToData();
        });
    },
    methods: {
        ...mapActions("modals", ["showModal"]),
        ...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
        MAS_Cal_Detail(selectDate, isViews) {
            if (isViews) {
                this.MAS_Cal_List(selectDate);
            } else {
                const modalInfo = {
                    title: "일정 작성 팝업",
                    width: "800px",
                    height: "600px",
                    obj: this.$modal,
                    component: MAS_Cal_Detail,
                    projectId: this.modalInfo.projectId,
                    selectDate: selectDate,
                };
                this.showModal(modalInfo);
            }
        },
        MAS_Cal_List(selectDate) {
            const modalInfo = {
                title: "상세 일정 팝업",
                width: "800px",
                height: "600px",
                obj: this.$modal,
                component: MAS_Cal_List,
                projectId: this.modalInfo.projectId,
                selectDate: selectDate,
                paperId: this.selectPaperId,
            };
            this.showModal(modalInfo);
        },
        getBoardAllList() {
            let obj = this;
            let param = {
                url: '/api/copaper/paper/getProjectPaperList',
                method: 'post',
                req: {
                    projectId: this.modalInfo.projectId,
                    limitRow: 400,
                    page: 0,
                    sortKey: 'paperTitle',
                    sortDesc: [true],
                }
            };
            obj.COWORK_REST_ACTION(param)
                .then((res) => {
                    paperList: [];
                    if (res.errorCode == null) {
                        obj.paperList = res.result.paperList.content;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        moveMonth(monthType) {
            this.todoMonth = {};
            let tempSelectMonth = this.selectMonth + "01";

            if (monthType == this.prevMonthType) {
                tempSelectMonth = this.$moment(tempSelectMonth).subtract(1, "months");
            } else {
                tempSelectMonth = this.$moment(tempSelectMonth).add(1, "months");
            }
            
            this.selectMonth = tempSelectMonth.format("YYYYMM");
            this.selectMonthTitle = tempSelectMonth.format("YYYY년 MM월");
            this.selectMonthStart = tempSelectMonth.startOf("months").format("YYYYMMDD");
            this.selectMonthEnd = tempSelectMonth.endOf("months").format("YYYYMMDD");
            this.startDate = this.$moment(this.selectMonthStart).startOf("weeks").format("YYYYMMDD");
            this.endDate = this.$moment(this.selectMonthEnd).endOf("weeks").format("YYYYMMDD");

            this.monthToData();
        },
        monthToData() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                projectId: this.modalInfo.projectId,
                paperId: this.selectPaperId,
                startDate: this.startDate,
                endDate: this.endDate,
            };
            reqData.req = obj.req;
            reqData.url = "/api/copaper/todo/monthToData";
            reqData.method = "post";

            obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
                let res = response.result;
                let todos = res.todoMonth;
                this.todoMonth = {};

                // 일별 데이터 생성
                for (let todokey in todos) {
                    let subList = todos[todokey];

                    for (let index in subList) {
                        let todo = subList[index];
                        let todoStartDate = todo.todoStartDate.replaceAll("-", "");
                        let todoEndDate = todo.todoEndDate.replaceAll("-", "");
                        let tempTodoEndDate = todoStartDate;

                        while (tempTodoEndDate <= todoEndDate) {
                            let list = [];
                            if (this.todoMonth[tempTodoEndDate] != null) {
                                list = this.todoMonth[tempTodoEndDate];
                            }

                            list.push(todo);
                            this.todoMonth[tempTodoEndDate] = list;
                            tempTodoEndDate = this.$moment(tempTodoEndDate).add(1, "days").format("YYYYMMDD");
                        }
                    }
                }

                let tempEndDate = this.startDate;
                this.weekCount = 0;
                let days = [];
                this.weekDays = [];
                this.todoSort = [];
                this.todoSort[this.weekCount] = {};
                let changeSort = {};

                while (tempEndDate <= this.endDate) {
                    let list = [];
                    let tempList = [];
                    let tempSort = this.todoSort[this.weekCount];

                    if (this.todoMonth[tempEndDate] != null) {
                        list = this.todoMonth[tempEndDate];
                    }

                    for (let index in list) {
                        let tempTodo = list[index];
                        let prevTempTodo = list[index - 1];
                        let prevIndex = prevTempTodo ? tempSort[prevTempTodo.todoMainId] : index;

                        // 일정 정렬 순서
                        if (tempSort[tempTodo.todoMainId] == null || tempSort[tempTodo.todoMainId] == undefined) {
                            if (prevIndex >= index) {
                                tempSort[tempTodo.todoMainId] = ++prevIndex;
                            } else {
                                tempSort[tempTodo.todoMainId] = index;
                            }
                        }

                        tempTodo.sort = tempSort[tempTodo.todoMainId];

                        // 일정 정렬 순서상 공백 처리
                        while (tempSort[tempTodo.todoMainId] > (++prevIndex)) {
                            tempList.push(null);
                        }
                        tempList.push(tempTodo);
                        this.todoSort[this.weekCount] = tempSort;
                    }

                    if (tempList.length > 0) {
                        let tempEmptyIndex = -1;
                        let tempSort = this.todoSort[this.weekCount];
                        let changeList = [];
                        let isChangePrevSort = false;
                        
                        // for (let tempIndex in tempList) {
                        //     let tempTodo = tempList[tempIndex];
                        //     changeList.push(tempTodo);

                        //     if (tempEndDate == "20240226") {
                        //         console.log("for=================", tempIndex, tempTodo);
                        //     }

                        //     if (tempTodo != null) {
                        //         if (tempEndDate == tempTodo.todoStartDate.replaceAll('-', '')) {
                        //             if (tempEmptyIndex > 0) {
                        //                 console.log("=======tempEmptyIndex ", tempEndDate, "title", tempTodo.todoTitle, "sort", tempSort[tempTodo.todoMainId], "changeSort", tempEmptyIndex);
                        //                 tempSort[tempTodo.todoMainId] = tempEmptyIndex;
                        //                 changeSort[tempTodo.todoMainId] = tempEmptyIndex;
                        //                 changeList[tempEmptyIndex] = tempTodo;
                        //                 changeList.pop();

                        //                 tempEmptyIndex = -1;
                        //             }
                        //         } else if (changeSort[tempTodo.todoMainId] != null && changeSort[tempTodo.todoMainId] != undefined) {
                        //             tempSort[tempTodo.todoMainId] = changeSort[tempTodo.todoMainId];

                        //             if (changeList[changeSort[tempTodo.todoMainId]] == null) {
                        //                 changeList.splice(changeSort[tempTodo.todoMainId], 1, tempTodo);
                        //             } else {
                        //                 changeList.splice(changeSort[tempTodo.todoMainId], 0, tempTodo);
                        //             }
                        //             changeList.pop();
                        //             isChangePrevSort = true;
                        //         }
                        //     } else if (tempTodo == null && tempEmptyIndex == -1 && !isChangePrevSort) {
                        //         tempEmptyIndex = tempIndex;
                        //     }
                        //}

                        //console.log("tempEndDate", tempEndDate, "changeList", changeList);
                        this.todoSort[this.weekCount] = tempSort;
                        this.todoMonth[tempEndDate] = tempList;
                    }

                    days.push(tempEndDate);
                    tempEndDate = this.$moment(tempEndDate).add(1, "days").format("YYYYMMDD");

                    if (days.length % 7 == 0) {
                        this.weekDays.push(days);
                        this.weekCount = this.weekCount + 1;
                        this.todoSort[this.weekCount] = {};
                        days = [];
                        changeSort = {};
                    }
                    
                }
            });
        },
        wheelEvent(event) {
            if (event.deltaY > 0) {
                this.moveMonth(null);
            } else if (event.deltaY < 0) {
                this.moveMonth(this.prevMonthType);
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/calendar/modal/MAS_Cal.vue